// @flow
import * as React from 'react';

import type { DurationUnit } from '@gandi/redux-resource-price';
import { useTranslator } from '@gandi/translate';

export default function useDurationTranslations(): {
  toLabel: { [DurationUnit]: { [string]: string } },
  toPriceLabel: { '1': string, '12': string },
  unitToLabel: { [DurationUnit]: string },
} {
  const { __ } = useTranslator();

  return React.useMemo(
    () => ({
      toLabel: {
        m: {
          '1': __('Monthly'),
          '12': __('Yearly'),
        },
        // y: {
        //   '1': __('each year'),
        // },
      },
      toPriceLabel: {
        '1': __('Monthly'),
        '12': __('Yearly'),
      },
      unitToLabel: {
        m: __('Monthly'),
        y: __('Yearly'),
      },
    }),
    [__],
  );
}
